import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e4dcace"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex message-wrapper" }
const _hoisted_2 = { class: "title-content" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CompanyLogo = _resolveComponent("CompanyLogo")!
  const _component_FbxButton = _resolveComponent("FbxButton")!
  const _component_ReturnOptions = _resolveComponent("ReturnOptions")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["overlay-background", { 'message-full-screen': _ctx.fullScreen }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["d-flex flex-column justify-content-between message-container", _ctx.image ? 'auto-height' : ''])
      }, [
        _renderSlot(_ctx.$slots, "before-title", {}, undefined, true),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("div", {
              class: _normalizeClass(["fb-form-heading title", { bold: _ctx.boldTitle }]),
              innerHTML: _ctx.titleText
            }, null, 10, _hoisted_3),
            (_ctx.subheadingText)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "subheading-text",
                  innerHTML: _ctx.subheadingText
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true),
            (_ctx.image)
              ? (_openBlock(), _createBlock(_component_CompanyLogo, {
                  key: 1,
                  company: _ctx.image
                }, null, 8, ["company"]))
              : _createCommentVNode("", true),
            (_ctx.subtitleText)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(["fb-form-heading", _ctx.subtitleStyle]),
                  innerHTML: _ctx.subtitleText
                }, null, 10, _hoisted_5))
              : _createCommentVNode("", true)
          ]),
          _hoisted_6,
          _renderSlot(_ctx.$slots, "warning", {}, undefined, true),
          _createElementVNode("div", {
            class: _normalizeClass(["footer-text", _ctx.footerStyle]),
            innerHTML: _ctx.footerText
          }, null, 10, _hoisted_7)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["content", {
                        'buttons-padding':
                            _ctx.includeReturnDeepLink && !_ctx.forceHideDeepLink,
                    }])
        }, [
          _createElementVNode("div", _hoisted_8, [
            (_ctx.rejectText !== '')
              ? (_openBlock(), _createBlock(_component_FbxButton, {
                  key: 0,
                  "button-text": _ctx.rejectText,
                  "show-loading": _ctx.rejectionLoading,
                  theme: _ctx.rejectTheme,
                  disabled: _ctx.rejectDisabled || _ctx.disabled,
                  onClick: _ctx.rejectClicked
                }, null, 8, ["button-text", "show-loading", "theme", "disabled", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.acceptText !== '')
              ? (_openBlock(), _createBlock(_component_FbxButton, {
                  key: 1,
                  "button-text": _ctx.acceptText,
                  "show-loading": _ctx.confirmationLoading,
                  theme: _ctx.acceptTheme,
                  disabled: _ctx.acceptDisabled || _ctx.disabled,
                  onClick: _ctx.acceptClicked
                }, null, 8, ["button-text", "show-loading", "theme", "disabled", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ], 2),
        (
                        (_ctx.includeReturnDeepLink || _ctx.fullScreen) &&
                        !_ctx.forceHideDeepLink
                    )
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([
                        'message-footer text-center',
                        { 'full-screen': _ctx.fullScreen },
                    ])
            }, [
              _createVNode(_component_ReturnOptions, { "in-modal": true })
            ], 2))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ], 2))
}